import { render, staticRenderFns } from "./CreateGroupModal.vue?vue&type=template&id=8b77c83c"
import script from "./CreateGroupModal.vue?vue&type=script&lang=js"
export * from "./CreateGroupModal.vue?vue&type=script&lang=js"
import style0 from "./CreateGroupModal.vue?vue&type=style&index=0&id=8b77c83c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports